<div *ngIf="dtOptions !== null">
  <table datatable [dtOptions]="dtOptions" class="dt-responsive">
  </table>
</div>

<!-- This button is used to be programmatically clicked because we weren't able to call the modal programmatically; 
  it shows a empty modal when trying to open it programmatically. -->
<button id="the-modal" type="button" class="btn btn-primary d-none" data-toggle="modal" [attr.data-target]="getDataTarget()">
  Open modal
</button>